import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { isEmpty } from 'lodash';
import { Observable } from 'rxjs';
import { finalize, take } from 'rxjs/operators';
import { ContactSelfServiceFormsService } from '../contact-self-service-forms.service';
import { IGeneralScreenSettings } from '../landing-screen/landing-screen.component';

@Component({
  selector: 'app-self-service-expiry-screen',
  templateUrl: './self-service-expiry-screen.component.html',
  styleUrls: ['./self-service-expiry-screen.component.scss'],
})
export class SelfServiceExpiryScreenComponent implements OnInit {
  contactType: string = '';
  settings: IGeneralScreenSettings;
  loaded: Boolean = false;
  browserLang: string;
  constructor(
    private router: Router,
    private contactSelfService: ContactSelfServiceFormsService,
    private titleService: Title,
    private sanitizer: DomSanitizer,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.browserLang = this.getBrowserLangTranslationString();
    this.titleService.setTitle('Contact self-service');
    this.getContactType()
      .pipe(take(1))
      .subscribe((contactType) => {
        this.contactType = contactType;
      });
    this.loadSchema();
  }

  getContactType(): Observable<string> {
    return this.contactSelfService.currentcontactTypeData;
  }

  getBrowserLangTranslationString(): string {
    return this.contactSelfService.getBrowserLang();
  }

  loadSchema(): void {
    this.contactSelfService
      .fetchSchema<IGeneralScreenSettings>('expiry', this.contactType, this.browserLang)
      .pipe(
        take(1),
        finalize(() => (this.loaded = true))
      )
      .subscribe(
        (schema) => {
          this.settings = !isEmpty(schema) ? schema : {};
          if (this.settings.logo) {
            this.settings.logoBase64 = 'data:image/svg+xml;base64,' + this.settings.logo;
          }
        },
        (err) => {
          this.snackBar.open('Unable to load form.');
        }
      );
  }

  tryAgain(): void {
    this.router.navigate(['./contact-form', 'landing', this.contactType]);
  }
}
